exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bbs-template[data-v-2efa99d8]{min-height:100px}", ""]);

